import { Logger } from 'data/common';

function debug(eventName, params) {
    Logger.debug(`TestBench : <---------- Event Received ${eventName}`, params);
}

function bindTestEvents(BoxInstance) {
    BoxInstance.socketOn('connected', function(args) {
        const { testers, boxes } = args;
        debug('connected', args);

        if (testers === undefined || boxes === undefined) return Logger.error("Arguments manquants sur l'envent socket connected", args);
        const storeBoxesList = BoxInstance.getState().environments.testbench.data.Boxes.get('list');

        let res = {};
        let newConnectedBoxes = [];
        let disconnectedBoxes = [];
        storeBoxesList.map((storeBox, storeBoxMac) => {
            if (!boxes[storeBoxMac]) disconnectedBoxes.push(storeBoxMac);
        });
        Object.keys(boxes).map(mac => {
            if (!storeBoxesList.hasIn([mac])) newConnectedBoxes.push(mac);
            res[mac] = { macAddress: mac };
        });

        if (newConnectedBoxes.length > 0) BoxInstance.emit('newConnectedBoxes', newConnectedBoxes);
        if (disconnectedBoxes.length > 0) BoxInstance.emit('disconnectedBoxes', disconnectedBoxes);

        BoxInstance.dispatch({
            type: `TESTBENCH__SET_BOX_LIST`,
            boxes: res
        });

        BoxInstance.dispatch({
            type: 'TESTBENCH__SET_USER_LIST',
            users: testers
        });
    });
    BoxInstance.socketOn('testResult', function(args) {
        debug('testResult', args);
        BoxInstance.emit('testResult', args);
    });
    BoxInstance.socketOn('unconfiguredFHECenterConnexion', function(args) {
        debug('unconfiguredFHECenterConnexion', args);
        BoxInstance.emit('unconfiguredFHECenterConnexion', args);
    });
    BoxInstance.socketOn('messageFromBox', function(args) {
        debug('messageFromBox', args);
        BoxInstance.emit('messageFromBox', args);
    });
}

export default function initBinds(BoxInstance) {
    bindTestEvents(BoxInstance);
}



// WEBPACK FOOTER //
// ./environments/testbench/eventsSocket/Boxes/binds.js